<template>

<div class="card my-3 d-none d-md-flex">
<div class="card-body">

<div><b>Payment methods</b></div>
<div class="logos mt-2">
  <div class="row">
    <div class="col">
      <img src="/images/absa.svg" class="mr-2 paylogo">
      <img src="/images/standardbank.svg" class="mr-2 paylogo">
      <img src="/images/fnb.svg" class="mr-2 paylogo">
      <img src="/images/nedbank.svg" class="mr-2 paylogo">
      <img src="/images/capitec.svg" class="mr-2 paylogo">
      <img src="/images/visa.svg" class="mr-2 paylogo">
      <img src="/images/mastercard.svg" class="paylogo">
    </div>
  </div>
</div>

</div>
</div>

</template>

<script>
export default {

  data() {
    return {
    };
  },

  created() {
    
  },

  methods: {

    },
};
</script> 

<style scoped>
.paylogo { height: 20px; }
</style>
